import { useRouterState } from "@tanstack/react-router";
import { useLayoutEffect, useRef, useState } from "react";

import { isBuildItemChildActive } from "./buildItemActive";
import type { BuildNavItem } from "./types";

// Group ids must be unique across every section passed in: they share a single
// open id, which is what makes the sections behave as one accordion.
export const useOpenBuildGroup = (items: BuildNavItem[]) => {
  const pathname = useRouterState({ select: s => s.location.pathname });
  const activeGroupId = items.find(item =>
    isBuildItemChildActive(item, pathname),
  )?.id;

  const [openGroupId, setOpenGroupId] = useState<string | undefined>(
    activeGroupId,
  );
  const previousActiveGroupId = useRef(activeGroupId);

  // Auto-open when route moves into a (possibly different) group.
  useLayoutEffect(() => {
    if (activeGroupId && previousActiveGroupId.current !== activeGroupId) {
      setOpenGroupId(activeGroupId);
    }
    previousActiveGroupId.current = activeGroupId;
  }, [activeGroupId]);

  const onToggleGroup = (id: string) =>
    setOpenGroupId(current => (current === id ? undefined : id));

  return { openGroupId, onToggleGroup };
};
